module.exports = __webpack_public_path__ + "img/IMG_1859.1a343936.jpg";